import React, { ComponentPropsWithRef, FC } from 'react'

type SvgProps = ComponentPropsWithRef<'svg'>
type Props = SvgProps

export const VideoBorderIcon: FC<Props> = ({ ...props }) => {
  return (
    <svg viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.4576 4.11083C25.7907 4.28224 26 4.62541 26 5V15C26 15.3746 25.7907 15.7178 25.4576 15.8892C25.1245 16.0606 24.7236 16.0315 24.4188 15.8137L17.4188 10.8137C17.156 10.626 17 10.323 17 10C17 9.67705 17.156 9.37398 17.4188 9.18627L24.4188 4.18627C24.7236 3.96854 25.1245 3.93943 25.4576 4.11083ZM19.7205 10L24 13.0568V6.94319L19.7205 10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C4.44772 4 4 4.44772 4 5V15C4 15.5523 4.44772 16 5 16H16C16.5523 16 17 15.5523 17 15V5C17 4.44772 16.5523 4 16 4H5ZM2 5C2 3.34315 3.34315 2 5 2H16C17.6569 2 19 3.34315 19 5V15C19 16.6569 17.6569 18 16 18H5C3.34315 18 2 16.6569 2 15V5Z"
        fill="white"
      />
      <path
        d="M27 5C27 4.25083 26.5813 3.56447 25.9152 3.22166C25.249 2.87886 24.4472 2.93708 23.8375 3.37253L20 6.11362V5C20 2.79086 18.2091 1 16 1H5C2.79086 1 1 2.79086 1 5V15C1 17.2091 2.79086 19 5 19H16C18.2091 19 20 17.2091 20 15V13.8864L23.8375 16.6275C24.4472 17.0629 25.249 17.1211 25.9152 16.7783C26.5813 16.4355 27 15.7492 27 15V5ZM21.4409 10L23 8.88638V11.1136L21.4409 10ZM5 15V5H16V10V15H5Z"
        stroke="#232936"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
